const config = {
  local: {
    payWithConvergeJS: 'https://api.demo.convergepay.com/hosted-payments/PayWithConverge.js'
  },
  staging: {
    payWithConvergeJS: 'https://api.demo.convergepay.com/hosted-payments/PayWithConverge.js'
  },
  prod: {
    payWithConvergeJS: 'https://api.convergepay.com/hosted-payments/PayWithConverge.js'
  }
}

export default config[process.env.VUE_APP_ENV]
